import {fetchPost} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const findVenueByCode = (
    code,
    successMethod,
    errorMethod,
    getAccessToken
) => {
    const params = {
        code: code
    };
    fetchPost(
        uri + "/findbycode",
        successMethod,
        errorMethod,
        params,
        getAccessToken);
};